import React from "react";
import { MdCookie } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const PrivacyModal = ({ showModal, onAccept, onDecline }) => {
    const navigate = useNavigate();

    const GoPrivacy = () => {
        navigate("privacy-policy");
    };

    return (
        <div className={`privacy_modal ${showModal ? "open" : "closed"}`}>
            <p className="privacy_modal_title"><MdCookie/> We value your privacy</p>
            <p className="privacy_modal_description">
                The Project E8 website uses cookies to help you have a superior and more admissible browsing experience.
            </p>
            <p className="read_more_span" onClick={GoPrivacy}>
                Read more
            </p>
            <div className="privacy_modal_btn_cont">
                <button className="privacy_modal_btn" onClick={onAccept}>Accept</button>
                <button className="privacy_modal_btn" onClick={onDecline}>Decline</button>
            </div>
        </div>
    );
};


export default PrivacyModal